/*@jsxRuntime classic @jsx React.createElement @jsxFrag React.Fragment*/
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import React from "react";
import {navigate} from "gatsby";
import {Box, Button, Link, Container} from "theme-ui";
import {Pricing, Title} from "./Blocks";
import {GumroadOverlay} from "./Gumroad";
function _createMdxContent(props) {
  const _components = Object.assign({
    h1: "h1",
    a: "a",
    p: "p",
    br: "br",
    h2: "h2"
  }, _provideComponents(), props.components);
  return React.createElement(React.Fragment, null, React.createElement(Container, {
    sx: {
      textAlign: 'center',
      width: [1, 3 / 4, 1 / 2],
      mb: [4, 4, 5]
    }
  }, React.createElement(_components.h1, {
    id: "hey-it-seems-that-you-dont-have-this"
  }, React.createElement(_components.a, {
    href: "#hey-it-seems-that-you-dont-have-this"
  }, "Hey it seems that you don’t have this!"))), "\n", React.createElement(React.Fragment, null, props.additionalCourse ? React.createElement(Container, {
    sx: {
      width: [1, 3 / 4, 1 / 2],
      mb: [4, 4, 5],
      textAlign: "center"
    }
  }, React.createElement(_components.p, null, "Please purchase ", props.title, " to access this page. If you already purchased, check your email and login top right."), React.createElement(GumroadOverlay, {
    variant: "big",
    code: props.gumroadCode,
    text: "Purchase the course"
  }), React.createElement(_components.br), "Cheers", React.createElement(_components.br), "~Swizec") : React.createElement(React.Fragment, null, props.GumroadCode ? React.createElement(Container, {
    sx: {
      width: [1, 3 / 4, 1 / 2],
      mb: [4, 4, 5],
      textAlign: "center"
    }
  }, React.createElement(_components.h2, null, "Upgrade to continue!"), React.createElement(GumroadOverlay, {
    variant: "big",
    code: props.GumroadCode,
    price: props.Price
  })) : React.createElement(React.Fragment, null, React.createElement(Container, {
    sx: {
      width: [1, 3 / 4, 1 / 2],
      mb: [4, 4, 5],
      textAlign: "center"
    }
  }, React.createElement(_components.h2, null, "Buy the course to continue!")), React.createElement(Pricing)))));
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? React.createElement(MDXLayout, props, React.createElement(_createMdxContent, props)) : _createMdxContent(props);
}
export default MDXContent;
